import { render, staticRenderFns } from "./Renewal5Management.vue?vue&type=template&id=98c89c82&scoped=true&"
import script from "./Renewal5Management.vue?vue&type=script&lang=js&"
export * from "./Renewal5Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c89c82",
  null
  
)

export default component.exports